import script from "./SecurityDesktopMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityDesktopMenu.vue?vue&type=script&setup=true&lang=js"

import "./SecurityDesktopMenu.vue?vue&type=style&index=0&id=28d7ebf2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28d7ebf2"]])

export default __exports__